export enum AttendancePageScreens {
  RECORD_ATTENDANCE = 'record-attendance',
  RECORDING_ATTENDANCE = 'recording-attendance',
  ATTENDANCE_RECORDED = 'attendance-recorded',
}
